/**
 * Constants for the Catalog module
 */

export const QUERY_STALE_TIME = 5 * 60 * 1000 // 5 minutes

export const SLIDER_ITEMS_PER_VIEW = {
  mobile: 2,
  tablet: 4,
  desktop: 5,
} as const

export const PHONE_NUMBER = '0377 100 000'
export const PHONE_HOURS = 'intre orele 08:00 - 17.00 (L-V)'

export const DISCONTINUED_CATEGORY_ID = 470
export const STIHL_CATEGORY_ID = 197

/** CMS page explaining TBI installments; anchor `#rate-tbi` is set in PageBuilder. */
export const TBI_INSTALLMENTS_URL = '/cum-cumpar.html#rate-tbi'
